(function(){
  'use strict';
  
  try {
    const head = document.head;
    if (!head) return;
    if (document.querySelector('link[data-hero-preload="1"]')) return;

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.setAttribute('data-hero-preload', '1');

    if (isMobile) {
      link.media = '(max-width: 768px)';
      link.href = '{{ section.settings.mobile-background-image | image_url: width: 900 }}';
      link.imagesrcset = '{{ section.settings.mobile-background-image | image_url: width: 600 }} 600w, {{ section.settings.mobile-background-image | image_url: width: 900 }} 900w';
      link.imagesizes = '100vw';
    } else {
      link.media = '(min-width: 769px)';
      link.href = '{{ section.settings.desktop-background-image | image_url: width: 1920 }}';
      link.imagesrcset = '{{ section.settings.desktop-background-image | image_url: width: 1280 }} 1280w, {{ section.settings.desktop-background-image | image_url: width: 1920 }} 1920w';
      link.imagesizes = '100vw';
    }

    head.appendChild(link);
  } catch (e) {
    console.warn('Banner preload failed', e);
  }
})();
